import { Navigate, Route, Routes } from 'react-router-dom';

import { usePartner } from './lib/partner-context.js';
import { AppsPage } from './routes/AppsPage.js';
import { InstallsPage } from './routes/InstallsPage.js';
import { LoginPage } from './routes/LoginPage.js';
import { PortalLayout } from './routes/PortalLayout.js';
import { ThemesPage } from './routes/ThemesPage.js';

export const App = (): React.JSX.Element => {
  const { user, isLoading } = usePartner();

  // Hold the render until the refresh-cookie restore settles, or a signed-in
  // developer sees the login screen flash on every reload.
  if (isLoading) {
    return (
      <div className="flex min-h-screen items-center justify-center text-sm text-muted-foreground">
        Loading…
      </div>
    );
  }

  if (!user) {
    return <LoginPage />;
  }

  return (
    <Routes>
      <Route element={<PortalLayout />}>
        <Route path="/apps" element={<AppsPage />} />
        <Route path="/themes" element={<ThemesPage />} />
        <Route path="/installs" element={<InstallsPage />} />
        <Route path="*" element={<Navigate to="/apps" replace />} />
      </Route>
    </Routes>
  );
};
